import React, { useEffect, useState } from 'react';
import AdminLayout from './components/adminlayout';
import { serverURL } from '../constants';
import axios from 'axios';
import AdminTable from './components/adminstable';

const Admins = () => {
    const [admins, setAdmin] = useState([]);
    const [users, setUser] = useState([]);

    useEffect(() => {
        sessionStorage.setItem('darkMode', false);
        async function fetchData() {
            const response = await axios.get(serverURL + `/api/getadmins`, { headers: { 'x-admin-email': sessionStorage.getItem('email') } });
            setAdmin(response.data.admins);
            setUser(response.data.users);
        }
        fetchData();
    }, []);

    return (
        <AdminLayout>
            <div className='p-6'>
                <AdminTable admin={admins} user={users} />
            </div>
        </AdminLayout>
    );
};
export default Admins;
